export default "attribute vec2 aPosition;\n\nvoid main(void){\n    gl_Position = vec4(aPosition, 0.0, 1.0);\n}";